// @ts-nocheck

import { colors } from '@lmc/common/constants'
import PropTypes from 'prop-types'
import React from 'react'
import { Icon } from '../Icon'
import { ProfileBadge } from '../ProfileBadge'

export default function ProfileField({
  alert,
  icons,
  badgeColor,
  badgeText,
  hidden = false,
  label,
  secondaryValue,
  style,
  value,
  'data-testid': dataTestId
}) {
  if (hidden) return null
  return (
    <div
      data-testid={dataTestId}
      style={{
        ...style,
        ...styles.wrapper,
        ...(!value && styles.noInfomationEntered)
      }}
    >
      <div style={styles.label}>{label}</div>
      <div
        style={{
          ...styles.value,
          color: colors.black,
          whiteSpace: 'pre-wrap'
        }}
      >
        {value || 'No information entered'}
        {value && secondaryValue && (
          <span style={styles.secondaryValue}>| {secondaryValue || ''}</span>
        )}
        {value && alert && (
          <div style={styles.alertContainer}>
            <div style={styles.alertFlex}>
              <div style={styles.alertDivider}>|</div>
              <Icon
                name="incident"
                fill={colors.red}
                size={16}
                style={styles.alertIcon}
              />
              <span style={styles.alert}>{alert}</span>
            </div>
          </div>
        )}
        {icons && <div style={styles.iconsContainer}>{icons}</div>}
      </div>
      {badgeText && (
        <ProfileBadge
          badgeColor={badgeColor}
          badgeText={badgeText}
          badgeStyle={styles.badge}
        />
      )}
    </div>
  )
}

const styles = {
  iconsContainer: {
    height: 20,
    textAlign: 'right',
    position: 'relative',
    bottom: 23
  },
  alert: {
    marginLeft: 4
  },
  alertContainer: {
    color: colors.red,
    display: 'inline-block',
    marginLeft: 4
  },
  alertDivider: {
    marginLeft: 4
  },
  alertFlex: {
    alignItems: 'center',
    display: 'flex'
  },
  alertIcon: {
    marginLeft: 4
  },
  badge: {
    fontSize: 12,
    fontWeight: 'bold',
    padding: '3px 12px',
    position: 'absolute',
    bottom: 6,
    right: 0,
    borderRadius: 15
  },
  label: {
    fontSize: 12,
    opacity: 0.39
  },
  secondaryValue: {
    color: colors.darkgrey,
    marginLeft: 4
  },
  value: {
    color: colors.darkgrey
  },
  wrapper: {
    borderBottom: '1px solid',
    borderColor: colors.grey,
    padding: '6px 0px',
    position: 'relative'
  },
  noInfomationEntered: {
    display: 'flex',
    flexDirection: 'column'
  }
}

ProfileField.propTypes = {
  icons: PropTypes.element,
  badgeColor: PropTypes.string,
  badgeText: PropTypes.string,
  hidden: PropTypes.bool,
  label: PropTypes.string.isRequired,
  secondaryValue: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  'data-testid': PropTypes.string
}
